module.exports = __webpack_public_path__ + "img/p6-p1-yu2.c9f4bd41.png";